import graphql from "../graphql";

const jobsQuery = graphql`
  query GetJobs(
    $locale: I18NLocaleCode!
    $pagination: PaginationArg
    $publicationState: PublicationState
  ) {
    jobs(
      publicationState: $publicationState
      locale: $locale
      pagination: $pagination
      sort: "order"
    ) {
      data {
        attributes {
          localizations {
            data {
              attributes {
                slug
                locale
                title
              }
            }
          }
          locale
          slug
          title
          description
          category
          employmentType
          location
          content
          employmentTypeBackground
        }
      }
    }
  }
`;

export default jobsQuery;
